histories-approval-canceled-by-exective
  span.event {this.locale().event}
  script(type="typescript").
    this.mixin('histories.base');
